/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Photos Gallery Data
 */

import img1 from '../assets/img/gallery/gallery01.jpg'
import img2 from '../assets/img/gallery/gallery02.jpg'
import img3 from '../assets/img/gallery/gallery03.jpg'
import img4 from '../assets/img/gallery/gallery04.jpg'
import img5 from '../assets/img/gallery/gallery05.jpg'
import img6 from '../assets/img/gallery/gallery06.jpg'
import img7 from '../assets/img/gallery/gallery07.jpg'
import img8 from '../assets/img/gallery/gallery08.jpg'
import img9 from '../assets/img/gallery/gallery09.jpg'
import img10 from '../assets/img/gallery/gallery10.jpg'
import img11 from '../assets/img/gallery/gallery11.jpg'
import img12 from '../assets/img/gallery/gallery12.jpg'
import img13 from '../assets/img/gallery/gallery13.jpg'
import img14 from '../assets/img/gallery/gallery14.jpg'
import img15 from '../assets/img/gallery/gallery15.jpg'
import img16 from '../assets/img/gallery/gallery16.jpg'
import img17 from '../assets/img/gallery/gallery17.jpg'
import img18 from '../assets/img/gallery/gallery18.jpg'
import img19 from '../assets/img/gallery/gallery19.jpg'
import img20 from '../assets/img/gallery/gallery20.jpg'
import img21 from '../assets/img/gallery/gallery21.jpg'
import img22 from '../assets/img/gallery/gallery22.jpg'
import img23 from '../assets/img/gallery/gallery23.jpg'
import img24 from '../assets/img/gallery/gallery24.jpg'
import img25 from '../assets/img/gallery/gallery25.jpg'
import img26 from '../assets/img/gallery/gallery26.jpg'
import img27 from '../assets/img/gallery/gallery27.jpg'
import img28 from '../assets/img/gallery/gallery28.jpg'
import img29 from '../assets/img/gallery/gallery29.jpg'
import img30 from '../assets/img/gallery/gallery30.jpg'
import img31 from '../assets/img/gallery/gallery31.jpg'
import img32 from '../assets/img/gallery/gallery32.jpg'
import img33 from '../assets/img/gallery/gallery33.jpg'
import img34 from '../assets/img/gallery/gallery34.jpg'
import img35 from '../assets/img/gallery/gallery35.jpg'
import img36 from '../assets/img/gallery/gallery36.jpg'
import img37 from '../assets/img/gallery/gallery37.jpg'
import img38 from '../assets/img/gallery/gallery38.jpg'
import img39 from '../assets/img/gallery/gallery39.jpg'
import img40 from '../assets/img/gallery/gallery40.jpg'
import img41 from '../assets/img/gallery/gallery41.jpg'
import img42 from '../assets/img/gallery/gallery42.jpg'
import img43 from '../assets/img/gallery/gallery43.jpg'

import imgWebp1 from '../assets/img/gallery/gallery01.webp'
import imgWebp2 from '../assets/img/gallery/gallery02.webp'
import imgWebp3 from '../assets/img/gallery/gallery03.webp'
import imgWebp4 from '../assets/img/gallery/gallery04.webp'
import imgWebp5 from '../assets/img/gallery/gallery05.webp'
import imgWebp6 from '../assets/img/gallery/gallery06.webp'
import imgWebp7 from '../assets/img/gallery/gallery07.webp'
import imgWebp8 from '../assets/img/gallery/gallery08.webp'
import imgWebp9 from '../assets/img/gallery/gallery09.webp'
import imgWebp10 from '../assets/img/gallery/gallery10.webp'
import imgWebp11 from '../assets/img/gallery/gallery11.webp'
import imgWebp12 from '../assets/img/gallery/gallery12.webp'
import imgWebp13 from '../assets/img/gallery/gallery13.webp'
import imgWebp14 from '../assets/img/gallery/gallery14.webp'
import imgWebp15 from '../assets/img/gallery/gallery15.webp'
import imgWebp16 from '../assets/img/gallery/gallery16.webp'
import imgWebp17 from '../assets/img/gallery/gallery17.webp'
import imgWebp18 from '../assets/img/gallery/gallery18.webp'
import imgWebp19 from '../assets/img/gallery/gallery19.webp'
import imgWebp20 from '../assets/img/gallery/gallery20.webp'
import imgWebp21 from '../assets/img/gallery/gallery21.webp'
import imgWebp22 from '../assets/img/gallery/gallery22.webp'
import imgWebp23 from '../assets/img/gallery/gallery23.webp'
import imgWebp24 from '../assets/img/gallery/gallery24.webp'
import imgWebp25 from '../assets/img/gallery/gallery25.webp'
import imgWebp26 from '../assets/img/gallery/gallery26.webp'
import imgWebp27 from '../assets/img/gallery/gallery27.webp'
import imgWebp28 from '../assets/img/gallery/gallery28.webp'
import imgWebp29 from '../assets/img/gallery/gallery29.webp'
import imgWebp30 from '../assets/img/gallery/gallery30.webp'
import imgWebp31 from '../assets/img/gallery/gallery31.webp'
import imgWebp32 from '../assets/img/gallery/gallery32.webp'
import imgWebp33 from '../assets/img/gallery/gallery33.webp'
import imgWebp34 from '../assets/img/gallery/gallery34.webp'
import imgWebp35 from '../assets/img/gallery/gallery35.webp'
import imgWebp36 from '../assets/img/gallery/gallery36.webp'
import imgWebp37 from '../assets/img/gallery/gallery37.webp'
import imgWebp38 from '../assets/img/gallery/gallery38.webp'
import imgWebp39 from '../assets/img/gallery/gallery39.webp'
import imgWebp40 from '../assets/img/gallery/gallery40.webp'
import imgWebp41 from '../assets/img/gallery/gallery41.webp'
import imgWebp42 from '../assets/img/gallery/gallery42.webp'
import imgWebp43 from '../assets/img/gallery/gallery43.webp'

export const PHOTOS = [
    {
        src: img1,
        srcWebp: imgWebp1,
        header: '',
        caption: 'Caramulo',
        altText: 'Paisagem Caramulo'
    },
    {
        src: img2,
        srcWebp: imgWebp2,
        header: '',
        caption: '',
        altText: 'Colmeia Beecaramulo'
    },
    {
        src: img3,
        srcWebp: imgWebp3,
        header: '',
        caption: '',
        altText: 'Sala de Estar'
    },
    {
        src: img4,
        srcWebp: imgWebp4,
        header: '',
        caption: '',
        altText: 'Sala de Refeições'
    },
    {
        src: img5,
        srcWebp: imgWebp5,
        header: 'Produtos',
        caption: 'Regionais',
        altText: 'Produtos Regionais'
    },
    {
        src: img6,
        srcWebp: imgWebp6,
        header: 'Suite Montanha 1',
        caption: 'Jacuzzi',
        altText: 'Jacuzzi'
    },
    {
        src: img7,
        srcWebp: imgWebp7,
        header: 'Caramulo',
        caption: '',
        altText: 'Paisagem Caramulo'
    },
    {
        src: img8,
        srcWebp: imgWebp8,
        header: 'Receção',
        caption: '',
        altText: 'Receção'
    },
    {
        src: img9,
        srcWebp: imgWebp9,
        header: 'A Casa',
        caption: 'Beecaramulo - Apiturismo',
        altText: 'Casa Beecaramulo - Apiturismo'
    },
    {
        src: img10,
        srcWebp: imgWebp10,
        header: '',
        caption: '',
        altText: 'Escadas'
    },
    {
        src: img11,
        srcWebp: imgWebp11,
        header: '',
        caption: '',
        altText: 'Sala de Estar - Lareira'
    },
    {
        src: img12,
        srcWebp: imgWebp12,
        header: '',
        caption: '',
        altText: 'Sala de Estar'
    },
    {
        src: img13,
        srcWebp: imgWebp13,
        header: 'Tasca',
        caption: '',
        altText: 'Tasca'
    },
    {
        src: img14,
        srcWebp: imgWebp14,
        header: '',
        caption: '',
        altText: 'Sala de Jantar'
    },
    {
        src: img15,
        srcWebp: imgWebp15,
        header: 'Suite',
        caption: 'Montanha 1',
        altText: 'Suite Montanha 1'
    },
    {
        src: img16,
        srcWebp: imgWebp16,
        header: 'Caramulo',
        caption: '',
        altText: 'Paisagem Caramulo'
    },
    {
        src: img17,
        srcWebp: imgWebp17,
        header: '',
        caption: '',
        altText: 'Detalhes'
    },
    {
        src: img18,
        srcWebp: imgWebp18,
        header: '',
        caption: '',
        altText: 'Detalhes'
    },
    {
        src: img19,
        srcWebp: imgWebp19,
        header: 'Quarto',
        caption: 'Mel',
        altText: 'Quarto Mel'
    },
    {
        src: img20,
        srcWebp: imgWebp20,
        header: 'Quarto',
        caption: 'Propólis',
        altText: 'Quarto Propólis'
    },
    {
        src: img21,
        srcWebp: imgWebp21,
        header: '',
        caption: '',
        altText: 'Detalhes'
    },
    {
        src: img22,
        srcWebp: imgWebp22,
        header: '',
        caption: '',
        altText: 'Detalhes'
    },
    {
        src: img23,
        srcWebp: imgWebp23,
        header: 'Quarto',
        caption: 'Pólen',
        altText: 'Quarto Pólen'
    },
    {
        src: img24,
        srcWebp: imgWebp24,
        header: 'Quarto',
        caption: 'Geleia Real',
        altText: 'Quarto Geleia Real'
    },
    {
        src: img25,
        srcWebp: imgWebp25,
        header: '',
        caption: '',
        altText: 'Suite Montanha'
    },
    {
        src: img26,
        srcWebp: imgWebp26,
        header: '',
        caption: '',
        altText: 'Suite Montanha'
    },
    {
        src: img27,
        srcWebp: imgWebp27,
        header: '',
        caption: '',
        altText: 'Apiário'
    },
    {
        src: img28,
        srcWebp: imgWebp28,
        header: '',
        caption: '',
        altText: 'Apicultor'
    },
    {
        src: img29,
        srcWebp: imgWebp29,
        header: '',
        caption: '',
        altText: 'Detalhes'
    },
    {
        src: img30,
        srcWebp: imgWebp30,
        header: '',
        caption: '',
        altText: 'Detalhes'
    },
    {
        src: img31,
        srcWebp: imgWebp31,
        header: '',
        caption: '',
        altText: 'Quarto Geleia Real'
    },
    {
        src: img32,
        srcWebp: imgWebp32,
        header: '',
        caption: '',
        altText: 'Suite Montanha 1'
    },
    {
        src: img33,
        srcWebp: imgWebp33,
        header: '',
        caption: '',
        altText: 'Suite Montanha'
    },
    {
        src: img34,
        srcWebp: imgWebp34,
        header: '',
        caption: '',
        altText: 'Quarto Pólen'
    },
    {
        src: img35,
        srcWebp: imgWebp35,
        header: '',
        caption: '',
        altText: 'Detalhes'
    },
    {
        src: img36,
        srcWebp: imgWebp36,
        header: 'A Casa',
        caption: 'Beecaramulo - Apiturismo',
        altText: 'Casa Beecaramulo - Apiturismo'
    },
    {
        src: img37,
        srcWebp: imgWebp37,
        header: '',
        caption: '',
        altText: 'Detalhes - Chá'
    },
    {
        src: img38,
        srcWebp: imgWebp38,
        header: '',
        caption: '',
        altText: 'Varanda - Suite Montanha 1'
    },
    {
        src: img39,
        srcWebp: imgWebp39,
        header: 'Ofurô',
        caption: '',
        altText: 'SPA - Ofurô'
    },
    {
        src: img40,
        srcWebp: imgWebp40,
        header: 'Caramulo',
        caption: '',
        altText: 'Paisagem Caramulo'
    },
    {
        src: img41,
        srcWebp: imgWebp41,
        header: 'Praia Fluvial',
        caption: 'Caramulo',
        altText: 'Paisagem Caramulo'
    },
    {
        src: img42,
        srcWebp: imgWebp42,
        header: '',
        caption: '',
        altText: 'Colmeia'
    },
    {
        src: img43,
        srcWebp: imgWebp43,
        header: '',
        caption: '',
        altText: 'Mel'
    },
]